import { fetchApi} from "@/utils/axios";
import URL from "@/api/urlConfig";

// 国际园区大屏接口

// 大屏填报分页列表
export function getManageList(data) {
   return fetchApi(URL.INTERNATION_MANAGE_LIST, data, "POST", "body");
}
// 新增大屏填报
export function addData(data) {
   return fetchApi(URL.INTERNATION_DATA_ADD, data, "POST", "body");
}
// 编辑大屏填报
export function updateData(data) {
   return fetchApi(URL.INTERNATION_DATA_EDIT, data, "POST", "body");
}
// 大屏填报详情
export function getDataDetail(params) {
   return fetchApi(URL.INTERNATION_DATA_DETAIL, params, "GET", "params");
}
// 删除大屏填报
export function deleteData(body) {
   return fetchApi(URL.INTERNATION_DATA_DELETE, body, "POST", "body");
}
// 启用或禁用大屏填报
export function changeStatus(body) {
   return fetchApi(URL.INTERNATION_DATA_CANGE_STATUS, body, "POST", "body");
}
